import { createSelector } from 'reselect';

import { ChannelWallpaper, State } from '../types';

export const channelDefaultRecipientSelector = (
  state: State
): string | boolean => state.channel.defaultRecipient;

export const isInChannel = (state: State): boolean =>
  Boolean(state.channel.name);

export const channelSelector = (state: State): State['channel'] =>
  state.channel;

export const selectChannelWallpapers = createSelector(
  channelSelector,
  (channel) => channel.wallpapers as ChannelWallpaper[]
);
